'use client'

import { useTranslations } from 'next-intl'

import { MButton } from '@/_components/medante/ui/m-button'
import { scrollToElementById } from '@/_lib/utils'

import ZJobsEyebrow from './z-jobs-eyebrow'

const AJobsSectionLife = () => {
	const t = useTranslations('pages.letsMakeWorldHealthier.life')

	const images = [
		`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/lets-make-world-healthier/michal-andrejco-selfie.webp `,
		`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/lets-make-world-healthier/medante-oslava.webp`,
		`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/lets-make-world-healthier/medante-stanok.webp`
	]

	return (
		<section
			id='cim-zijeme'
			className='pt-12 md:pt-18 lg:pt-24 pb-12 md:pb-22 lg:pb-28 bg-m-sand-3'
		>
			<div className='wrapper2 grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-8 lg:items-stretch'>
				<div className='flex flex-col justify-center'>
					<ZJobsEyebrow>{t('eyebrow')}</ZJobsEyebrow>
					<h2 className='type-medante-h1'>
						{t.rich('title', {
							br: () => <br />
						})}
					</h2>
					<div className='mt-4 text-base font-light max-w-md'>
						<p>{t('text')}</p>
					</div>
					<div className='mt-6 lg:mt-8'>
						<MButton
							onClick={() => {
								scrollToElementById('nase-hodnoty')
							}}
							variant='purple'
						>
							{t('ourValues')}
						</MButton>
					</div>
				</div>

				<div className='flex w-full flex-row flex-nowrap items-stretch justify-center gap-3 lg:gap-4 max-w-96 lg:max-w-none'>
					{images.map((src, index) => (
						<div
							key={src}
							className='relative h-[213px] min-w-0 flex-1 overflow-hidden rounded-3xl lg:h-[310px] lg:w-[155px] lg:shrink-0 lg:flex-none'
						>
							<img
								src={src}
								alt={`${t('imageAlt')} ${index + 1}`}
								className='absolute inset-0 size-full object-cover'
							/>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

export default AJobsSectionLife
